module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Navigation/Arrows-v-2249db36f5401d458b35266769eb41fc.svg";